import { shouldPolyfill } from '@formatjs/intl-datetimeformat/should-polyfill';

function getLocale(locale) {
    if (locale === 'da-DK') return import(`@formatjs/intl-datetimeformat/locale-data/da`);
    if (locale === 'sv-SE') return import(`@formatjs/intl-datetimeformat/locale-data/se`);
    if (locale === 'nb-NO') return import(`@formatjs/intl-datetimeformat/locale-data/no`);

    return import(`@formatjs/intl-datetimeformat/locale-data/da`);
}

export default async function polyfill(locale) {
    const unsupportedLocale = shouldPolyfill(locale);
    // This locale is supported
    if (!unsupportedLocale) {
        return;
    }
    // Load the polyfill 1st BEFORE loading data
    await import('./numberFormat');
    await import('@formatjs/intl-datetimeformat/polyfill-force');

    // Parallelize CLDR data loading
    const dataPolyfills = [import('@formatjs/intl-datetimeformat/add-all-tz'), getLocale(locale)];
    await Promise.all(dataPolyfills);

    if ('__setDefaultTimeZone' in Intl.DateTimeFormat) {
        (Intl.DateTimeFormat as any).__setDefaultTimeZone('Europe/Copenhagen');
    }
}
